/* Clétte social stories — storefront player.
 *
 * Native port of the Profit AI "Video Stories" app block player. Each section
 * instance renders a JSON config; this file finds every config on the page and
 * boots one player per section, so two instances on one page never collide.
 *
 * Cart adds go through window.CletteCherryCart (sections/clette-cherry-cart-drawer.liquid)
 * when it is present, so an add opens the theme's own drawer instead of a
 * second cart UI. Without it the shopper is sent to the product page.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 749;

  function getYouTubeId(url) {
    if (!url) return null;
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([^?&"'>]+)/);
    return m ? m[1] : null;
  }

  function initStories(sectionId, stories) {
    var section = document.getElementById('clette-vs-' + sectionId);
    if (!section || !stories.length) return;

    // 100vw counts the scrollbar gutter; clientWidth does not. The full-width
    // modifier reads this instead so it never overflows the page horizontally.
    function setViewportVar() {
      section.style.setProperty('--clette-vs-vw', document.documentElement.clientWidth + 'px');
    }
    setViewportVar();
    window.addEventListener('resize', setViewportVar);

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var previews = section.querySelectorAll('[data-clette-vs-preview]');

    if (previews.length && !reduceMotion) {
      var tryPlay = function (v) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryPlay(entry.target);
            else entry.target.pause();
          });
        }, { threshold: 0.3 });
        Array.prototype.forEach.call(previews, function (v) { io.observe(v); });
      } else {
        Array.prototype.forEach.call(previews, tryPlay);
      }
    }

    var scrollEl = section.querySelector('[data-clette-vs-scroll]');
    var navPrev = section.querySelector('.clette-vs__nav--prev');
    var navNext = section.querySelector('.clette-vs__nav--next');
    var overlay = document.getElementById('clette-vs-player-' + sectionId);
    var video = overlay.querySelector('.clette-vs__feed-video');
    var iframe = overlay.querySelector('.clette-vs__feed-iframe');
    var playBtn = overlay.querySelector('.clette-vs__feed-play');
    var closeBtn = overlay.querySelector('.clette-vs__feed-close');
    var progress = overlay.querySelector('.clette-vs__feed-progress');
    var progressFill = overlay.querySelector('.clette-vs__feed-progress-fill');
    var muteBtn = overlay.querySelector('[data-action="mute"]');
    var productCard = overlay.querySelector('.clette-vs__feed-product');
    var productImg = overlay.querySelector('.clette-vs__feed-product-img');
    var productTitle = overlay.querySelector('.clette-vs__feed-product-title');
    var productPrice = overlay.querySelector('.clette-vs__feed-product-price');
    var productOpts = overlay.querySelector('.clette-vs__feed-product-opts');
    var productBtn = overlay.querySelector('.clette-vs__feed-product-btn');
    var toast = overlay.querySelector('.clette-vs__feed-toast');
    var storyEls = section.querySelectorAll('.clette-vs__story');

    var currentIndex = 0;
    var isMuted = true;
    var isYouTube = false;
    var progressInterval = null;
    var buyBusy = false;
    var variantToken = 0;
    var currentVariants = null;

    function updateNav() {
      if (navPrev) navPrev.classList.toggle('clette-vs--hidden', scrollEl.scrollLeft <= 10);
      if (navNext) {
        navNext.classList.toggle(
          'clette-vs--hidden',
          scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - 10
        );
      }
    }

    if (navPrev) navPrev.addEventListener('click', function () { scrollEl.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (navNext) navNext.addEventListener('click', function () { scrollEl.scrollBy({ left: 300, behavior: 'smooth' }); });
    scrollEl.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);

    Array.prototype.forEach.call(storyEls, function (el) {
      el.addEventListener('click', function () { openPlayer(parseInt(el.dataset.index, 10)); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPlayer(parseInt(el.dataset.index, 10));
        }
      });
    });

    function isMobile() { return window.innerWidth <= MOBILE_MAX; }

    function openPlayer(index) {
      currentIndex = index;
      loadStory(index);
      overlay.classList.add('clette-vs--active');
      if (isMobile()) document.body.style.overflow = 'hidden';
      if (storyEls[index]) storyEls[index].classList.add('clette-vs--viewed');
      closeBtn.focus();
    }

    function closePlayer() {
      overlay.classList.remove('clette-vs--active');
      document.body.style.overflow = '';
      video.pause();
      video.removeAttribute('src');
      video.load();
      iframe.src = '';
      iframe.classList.add('clette-vs--hidden');
      video.classList.remove('clette-vs--hidden');
      window.clearInterval(progressInterval);
      isYouTube = false;
      if (storyEls[currentIndex]) storyEls[currentIndex].focus();
    }

    function startProgress() {
      window.clearInterval(progressInterval);
      progressFill.style.width = '0%';
      progressInterval = window.setInterval(function () {
        if (video.duration) progressFill.style.width = (video.currentTime / video.duration * 100) + '%';
      }, 100);
    }

    function loadStory(index) {
      var story = stories[index];
      if (!story) {
        productCard.classList.add('clette-vs--hidden');
        return;
      }

      video.pause();
      video.removeAttribute('src');
      iframe.src = '';
      window.clearInterval(progressInterval);
      progressFill.style.width = '0%';

      var ytId = getYouTubeId(story.video);

      if (ytId) {
        isYouTube = true;
        video.classList.add('clette-vs--hidden');
        iframe.classList.remove('clette-vs--hidden');
        iframe.src = 'https://www.youtube.com/embed/' + ytId +
          '?autoplay=1&mute=' + (isMuted ? '1' : '0') + '&playsinline=1&rel=0&modestbranding=1';
        playBtn.classList.add('clette-vs--hidden');
        progress.classList.add('clette-vs--hidden');
        if (muteBtn) muteBtn.classList.add('clette-vs--hidden');
      } else {
        isYouTube = false;
        iframe.classList.add('clette-vs--hidden');
        video.classList.remove('clette-vs--hidden');
        progress.classList.remove('clette-vs--hidden');
        if (muteBtn) muteBtn.classList.remove('clette-vs--hidden');

        var src = '';
        if (story.videoSources && story.videoSources.length) {
          var mp4 = null;
          for (var i = 0; i < story.videoSources.length; i++) {
            if (story.videoSources[i].mimeType && story.videoSources[i].mimeType.indexOf('mp4') !== -1) {
              mp4 = story.videoSources[i];
              break;
            }
          }
          src = (mp4 || story.videoSources[0]).url;
        } else if (story.video) {
          src = story.video;
        }
        video.src = src;
        video.muted = isMuted;
        video.addEventListener('canplay', function handler() {
          video.removeEventListener('canplay', handler);
          var p = video.play();
          if (p && p.then) {
            p.then(function () { playBtn.classList.add('clette-vs--hidden'); })
             .catch(function () { playBtn.classList.remove('clette-vs--hidden'); });
          }
        });
        video.load();
        startProgress();
      }

      if (story.product) {
        productCard.classList.remove('clette-vs--hidden');
        productImg.src = story.product.image || '';
        productImg.alt = story.product.title || '';
        productTitle.textContent = story.product.title || '';
        productPrice.textContent = story.product.price || '';
        if (buyBusy) return;
        syncProductButton(story);
      } else {
        productCard.classList.add('clette-vs--hidden');
        if (buyBusy) return;
        syncProductButton(null);
      }
    }

    // The card paints instantly from Liquid data, then upgrades to the live
    // variant list. The token drops a slow response for a story the shopper has
    // already advanced past.
    function loadVariants(story) {
      var token = ++variantToken;
      currentVariants = null;
      productOpts.innerHTML = '';
      productOpts.classList.add('clette-vs--hidden');

      var handle = story && story.product && story.product.handle;
      if (!handle || !window.fetch) return;

      window.fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'products/' + handle + '.js'
        : '/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(String(r.status))); })
        .then(function (live) {
          if (token !== variantToken || buyBusy) return;
          if (!live.variants || live.variants.length < 2) return;
          currentVariants = live.variants;
          (live.options || []).forEach(function (optName, optIndex) {
            var values = [];
            live.variants.forEach(function (v) {
              var val = v.options[optIndex];
              if (values.indexOf(val) === -1) values.push(val);
            });
            if (values.length < 2) return;
            var select = document.createElement('select');
            select.className = 'clette-vs__feed-product-opt';
            select.setAttribute('aria-label', typeof optName === 'string' ? optName : (optName.name || 'Option'));
            select.dataset.optionIndex = String(optIndex);
            values.forEach(function (val) {
              var opt = document.createElement('option');
              opt.value = val;
              opt.textContent = val;
              select.appendChild(opt);
            });
            select.addEventListener('change', applySelection);
            productOpts.appendChild(select);
          });
          if (!productOpts.children.length) return;
          productOpts.classList.remove('clette-vs--hidden');
          preselect(live);
          applySelection();
        })
        .catch(function () {});
    }

    function preselect(live) {
      var first = null;
      for (var i = 0; i < live.variants.length; i++) {
        if (live.variants[i].available) { first = live.variants[i]; break; }
      }
      if (!first) first = live.variants[0];
      Array.prototype.forEach.call(productOpts.children, function (select) {
        select.value = first.options[parseInt(select.dataset.optionIndex, 10)];
      });
    }

    function selectedVariant() {
      if (!currentVariants) return null;
      var chosen = Array.prototype.map.call(productOpts.children, function (s) { return s.value; });
      for (var i = 0; i < currentVariants.length; i++) {
        var v = currentVariants[i];
        var match = true;
        Array.prototype.forEach.call(productOpts.children, function (s, n) {
          if (v.options[parseInt(s.dataset.optionIndex, 10)] !== chosen[n]) match = false;
        });
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      return format === 'USD' || format === '' ? '$' + amount : amount + ' ' + format;
    }

    function applySelection() {
      if (buyBusy || !currentVariants) return;
      var v = selectedVariant();
      if (!v) {
        productBtn.textContent = 'Unavailable';
        productBtn.disabled = true;
        return;
      }
      productBtn.dataset.variantId = String(v.id);
      productPrice.textContent = formatMoney(v.price);
      productBtn.textContent = v.available ? 'Shop' : 'Sold out';
      productBtn.disabled = !v.available;
    }

    function syncProductButton(story) {
      loadVariants(story);
      var p = story && story.product;
      if (p) {
        productBtn.textContent = p.available ? 'Shop' : 'Sold out';
        productBtn.disabled = !p.available;
        productBtn.dataset.variantId = p.variantId == null ? '' : String(p.variantId);
        productBtn.dataset.productUrl = p.url || '';
      } else {
        productBtn.disabled = true;
        productBtn.dataset.variantId = '';
        productBtn.dataset.productUrl = '';
      }
    }

    function navigate(dir) {
      var next = currentIndex + dir;
      if (next < 0 || next >= stories.length) return;
      currentIndex = next;
      loadStory(currentIndex);
      if (storyEls[currentIndex]) storyEls[currentIndex].classList.add('clette-vs--viewed');
    }

    video.addEventListener('ended', function () {
      if (currentIndex < stories.length - 1) navigate(1);
      else closePlayer();
    });

    video.addEventListener('click', function (e) {
      e.stopPropagation();
      if (video.paused) {
        var p = video.play();
        if (p && p.then) p.then(function () { playBtn.classList.add('clette-vs--hidden'); }).catch(function () {});
      } else {
        video.pause();
        playBtn.classList.remove('clette-vs--hidden');
      }
    });

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isYouTube) return;
      var p = video.play();
      if (p && p.then) p.then(function () { playBtn.classList.add('clette-vs--hidden'); }).catch(function () {});
    });

    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closePlayer(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePlayer(); });

    Array.prototype.forEach.call(overlay.querySelectorAll('[data-action]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var action = btn.dataset.action;
        if (action === 'mute') {
          isMuted = !isMuted;
          video.muted = isMuted;
          btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
          overlay.querySelector('.clette-vs__icon-unmuted').style.display = isMuted ? 'block' : 'none';
          overlay.querySelector('.clette-vs__icon-muted').style.display = isMuted ? 'none' : 'block';
        } else if (action === 'prev') {
          navigate(-1);
        } else if (action === 'next') {
          navigate(1);
        }
      });
    });

    function addToCart(variantId) {
      var api = window.CletteCherryCart;
      if (api && typeof api.addProduct === 'function' && api.canAjax()) {
        var form = document.createElement('form');
        form.method = 'post';
        form.action = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root : '/') + 'cart/add';
        form.setAttribute('accept-charset', 'UTF-8');
        form.enctype = 'multipart/form-data';
        form.hidden = true;
        var id = document.createElement('input');
        id.type = 'hidden';
        id.name = 'id';
        id.value = String(variantId);
        var qty = document.createElement('input');
        qty.type = 'hidden';
        qty.name = 'quantity';
        qty.value = '1';
        form.appendChild(id);
        form.appendChild(qty);
        document.body.appendChild(form);
        return api.addProduct(form, productBtn)
          .then(function () { return true; })
          .catch(function () { return false; })
          .then(function (ok) { form.remove(); return ok; });
      }
      if (!window.fetch) return Promise.resolve(false);
      return window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    productBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (productBtn.disabled || buyBusy) return;
      var variantId = productBtn.dataset.variantId;
      var productUrl = productBtn.dataset.productUrl;
      if (!variantId) {
        if (productUrl) window.location.href = productUrl;
        return;
      }
      buyBusy = true;
      productBtn.textContent = 'Adding...';
      productBtn.disabled = true;
      addToCart(variantId).then(function (added) {
        buyBusy = false;
        if (!added) {
          if (productUrl) window.location.href = productUrl;
          else syncProductButton(stories[currentIndex]);
          return;
        }
        productBtn.textContent = 'Added';
        toast.classList.remove('clette-vs--hidden');
        // The player is a fullscreen overlay above the cart drawer the add just
        // opened. Close it after a short beat so "Added" is still readable.
        window.setTimeout(closePlayer, 900);
        window.setTimeout(function () {
          toast.classList.add('clette-vs--hidden');
          if (productBtn.textContent === 'Added') syncProductButton(stories[currentIndex]);
        }, 2000);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('clette-vs--active')) return;
      if (e.key === 'Escape') closePlayer();
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    (function () {
      var startY = 0;
      var wrap = overlay.querySelector('.clette-vs__feed-video-wrap');
      wrap.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        var dy = startY - e.changedTouches[0].clientY;
        if (Math.abs(dy) > 50) navigate(dy > 0 ? 1 : -1);
      }, { passive: true });
    })();

    window.setTimeout(updateNav, 100);
  }

  function boot() {
    var configs = document.querySelectorAll('script[data-clette-vs-config]');
    for (var i = 0; i < configs.length; i++) {
      var node = configs[i];
      if (node.getAttribute('data-clette-vs-booted')) continue;
      node.setAttribute('data-clette-vs-booted', '1');
      try {
        var cfg = JSON.parse(node.textContent);
        initStories(cfg.sectionId, cfg.stories || []);
      } catch (err) {
        // A malformed config must not take down another instance on the page.
        if (window.console) console.warn('[clette-social-stories] bad config', err);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
